import axios from "@/api/config/request"
import {BASE_API} from './index'

// 契约锁
const ContractAPI = {
  // 获取开通信息
  getContractAuthInfo: (params) => {
    return axios({
      url: `${BASE_API}/contract/auth/info`,
      method: 'get',
      params
    })
  },
  // 提交开通信息
  submitContractAuth: (data) => {
    return axios({
      url: `${BASE_API}/contract/auth/submit`,
      method: 'post',
      data
    })
  },
  getUrl: (params) => {
    return axios({
      url: `${BASE_API}/contract/auth/pageUrl`,
      method: 'get',
      params
    })
  }
}
export default ContractAPI